import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PayPublicServicesAutomaticService {
  constructor(
    private http: HttpClient,
    private storageServices: StorageService
  ) {}

  async getCategories(): Promise<any[]> {
    return new Promise((resolve, reject) =>
      this.http
        .get(
          `${
            environment.gluky.algoliaSearchUrl
          }puntored_proxy_prd/index/categories?search=${''}`
        )
        .subscribe(
          async (res: any) => {
            resolve(res.hits);
          },
          (err) => {
            console.error('productsApiBasePath does not have permission', err);
            reject(err);
          }
        )
    );
  }

  async CheckAgreement(product): Promise<any[]> {
    const claims = await this.storageServices.get('gnx-claims');
    return new Promise((resolve, reject) =>
      this.http
        /* .post(`${environment.gluky.ordersApiBasePatch}/public-services/${claims.uid}/check-agreement`,product ) */
        .post(
          `${environment.gluky.ordersApiBasePatch}/puntored/${claims.uid}/check-agreement`,
          product
        )
        .subscribe(
          async (res: any) => {
            resolve(res);
          },
          (err) => {
            console.error('productsApiBasePath does not have permission', err);
            reject(err);
          }
        )
    );
  }

  async getProviders(CategoryId): Promise<any[]> {
    return new Promise((resolve, reject) =>
      this.http
        .get(
          `${environment.frontendPuntoRedApi}/front/public-services/agreements?categoryId=${CategoryId}`
        )
        .subscribe(
          async (res: any) => {
            resolve(res.data);
          },
          (err) => {
            console.error('productsApiBasePath does not have permission', err);
            reject(err);
          }
        )
    );
  }

  getStoreName(search, filter?, hasfilter = false) {
    const requestOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return new Promise((resolve, reject) =>
      this.http
        .get(
          `${
            environment.gluky.algoliaSearchUrl
          }puntored_proxy_prd/index/agreements?${
            hasfilter ? 'filters=' + filter + '&' : ''
          }search=${search}`,
          requestOptions
        )
        .subscribe(
          (data) => {
            // console.log("resultado", data);
            resolve(data);
          },
          (error) => {
            console.log('cdc error', error);
            reject(error);
          }
        )
    );
  }

  async CalculateValueServices(data) {
    return new Promise((resolve, reject) =>
      this.http
        .post(
          `${environment.gluky.ordersApiBasePatch}/puntored/calculate-price`,
          data
        )
        .subscribe(
          async (res: any) => {
            resolve(res);
          },
          (err) => {
            console.error('productsApiBasePath does not have permission', err);
            reject(err);
          }
        )
    );
  }
}
